import React from 'react';
import 'tippy.js/dist/tippy.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Dashboard from './pages/Dashboard';
import UsersList from './pages/UsersList';
import UserEdit from './pages/UserEdit';
import UserView from './pages/UserView';
import Calendar from './pages/Calendar';
import LockedUsers from './pages/LockedUsers';
import ResetPassword from './pages/ResetPassword';
import EventPdfUpload from './pages/EventPdfUpload';


function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-white">
          <Routes>
              <Route path="/" element={
                <PublicRoute>
                  <div className="min-h-screen">
                    <LandingPage />
                  </div>
                </PublicRoute>
              } />
              <Route path="/home" element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <Home />
                    </div>
                  </>
                </PrivateRoute>
              } />
              <Route path="/login" element={
                <PublicRoute>
                  <>
                    <Navbar />
                    <div className="min-h-screen">
                      <Login />
                    </div>
                  </>
                </PublicRoute>
              } />
              <Route path="/register" element={
                <PublicRoute>
                  <>
                    <Navbar />
                    <div className="min-h-screen">
                      <Register />
                    </div>
                  </>
                </PublicRoute>
              } />
              <Route path="/reset-password/:token" element={
                <div className="min-h-screen">
                  <ResetPassword />
                </div>
              } />
              <Route path="/profile" element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <Profile />
                    </div>
                  </>
                </PrivateRoute>
              } />
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <Dashboard />
                    </div>
                  </>
                </PrivateRoute>
              } />
              <Route path="/users" element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <UsersList />
                    </div>
                  </>
                </PrivateRoute>
              } />
              <Route path="/users/view/:id" element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <UserView />
                    </div>
                  </>
                </PrivateRoute>
              } />
              <Route path="/users/edit/:id" element={
                <PrivateRoute adminOnly={true}>
                  <>
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <UserEdit />
                    </div>
                  </>
                </PrivateRoute>
              } />
              {/* Fixed Calendar route */}
              <Route path="/calendar" element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <Calendar />
                    </div>
                  </>
                </PrivateRoute>
              } />
              <Route path="/locked-users" element={
                <PrivateRoute adminOnly={true}>
                  <>
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <LockedUsers />
                    </div>
                  </>
                </PrivateRoute>
              } />
              <Route path="/events/:id/pdfs" element={
                <PrivateRoute>
                  <>
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <EventPdfUpload />
                    </div>
                  </>
                </PrivateRoute>
              } />
            </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;